/**
 * useUserLabels — mapa `userId → wyświetlana nazwa` (F17 T17.1.7 follow-up).
 *
 * Reużywa `useUsersList` (lista userów tenanta) i buduje mapę `displayName ?? email`
 * do zamiany surowych UUID na nazwiska w tabelach procesów (`ProcessStepsTable`
 * w bannerze i w zakładce „Akceptacje”).
 *
 * Degradacja bez wyjątku: gdy lista się nie wczyta (błąd sieci albo 403 — domyślna
 * rola „Członek” ma `crm_core.users.view` tylko w scope 'own', więc listowanie
 * userów jej nie przejdzie) → pusta mapa → tabela pokazuje surowy UUID. To stan
 * „nie gorszy niż bez hooka”, nie awaria.
 *
 * Znane ograniczenia (świadome, MVP): akceptanci spoza pierwszych 100 userów
 * oraz soft-deleted (poza listą) nie rozwiążą się na nazwisko.
 */

import { useMemo } from 'react';

import { useUsersList } from '@/lib/use-permissions';

export function useUserLabels(): Record<string, string> {
  const { data } = useUsersList({ limit: 100 });

  return useMemo(() => {
    const map: Record<string, string> = {};
    for (const u of data?.users ?? []) {
      map[u.id] = u.displayName ?? u.email;
    }
    return map;
  }, [data]);
}
